import { getPageUrl } from './utils/get-page-url';

import type { Link, Maybe } from '@/generated/graphql';

type PageLinkObj = {
  href: string;
  target: '_blank' | '_self';
  download?: boolean;
};

export const getPageLink = (link: Link | Maybe<Link>): PageLinkObj => {
  if (link) {
    const linkTarget = link.openInNewTab ? '_blank' : '_self';
    if (link.externalLink) {
      return { href: link.externalLink, target: linkTarget };
    }

    if (link.internalLink) {
      return { href: getPageUrl(link.internalLink), target: linkTarget };
    }

    if (link.internalCampaignLink?.slug) {
      return {
        href: `/p/${link.internalCampaignLink.slug}`,
        target: linkTarget,
      };
    }

    if (link.pdfLink) {
      return { href: link.pdfLink.url || '', download: true, target: '_blank' };
    }
  }

  return { href: '', target: '_self' };
};

/**
 * Use this for getting the title of a link.
 * If the title is not manually specified, it will use the title of the linked page.
 */
export const getLinkTitle = (link: Link | Maybe<Link>) => {
  if (link?.title) {
    return link.title;
  }

  if (link?.internalLink) {
    return link.internalLink.title;
  }

  return '';
};
